'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Back';
import Dashboard from 'Components/Lists/Dashboard';
import PackOrderRow from 'Components/Lists/Rows/PackOrder';
import { action } from 'Shared/Routes';
let app = window.app;
const header = [{
  name: 'created_at',
  label: 'Date de commande',
  sortable: false
}, {
  name: 'payment_type',
  label: 'Type de paiement',
  sortable: false
}, {
  name: 'payment_status',
  label: 'Statut du paiement',
  sortable: false
}, {
  name: 'total_amount_ttc',
  label: 'Montant total TTC',
  sortable: false
}];
const fields = header.map(infos => infos.name);

// Non-research like client picker, select, date picker, etc
const fields_without_timeout = [];
export default class MyOrdersPage extends Component {
  state = {};
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const company_id = app?.state?.session?.user?.id;
    let filters = {
      company_id: company_id
    };
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Mes commandes"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-padding-top-0\r no-horizontal-padding"
    }, /*#__PURE__*/React.createElement(Dashboard, {
      model: "PackOrder",
      url: action('getAllPackOrders'),
      header: header,
      fields: fields,
      component: PackOrderRow,
      "order-by": "type",
      order: "asc",
      "items-per-page": 30,
      filters: filters
    })))));
    return output;
  }
}
